<template>
  <div class="page">
    <div class="locations-grey locations-generic waiver">
  If you bring a child or children under 18 years of age (other than your own children or direct family members), you must provide a parental waiver, signed by each child’s parent or legal guardian. Persons 16 to 17 years of age can rent without adult supervision provided we have a signed parental waiver on site. Persons under 18 years of age will not be permitted to paddle alone.<br><br>
  <a class="btn btn-primary paper" href="ParentalWaiver.doc">Parental Waiver</a> <br> 
 <a href="mailto:Info@ChicagoRiverPaddle.com">Info@ChicagoRiverPaddle.com</a> 
  </div>
  </div>
</template>

<script>
export default {
  name: 'Waiver',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.waiver {
width: 50%;
align-self: center;
}
.page {
  background-image: url("../../assets/pic6.png");
  flex-direction: column;
  padding-left: 20px;
}
section {
  margin-bottom: 10px;
}
a:hover {
  color:#9f001c !important;

}
a {
  color: white; 
}
a.paper {
    color: white !important;
    align-self: center;
}
.btn {
    margin-bottom: 10px;
}
@media screen and (max-width: 768px) {
  .waiver {
    width: 90%;
  }
}
</style>
